import uuid from "../../../library/uuid.js";
import global from "../../global.js";
import ObjectHandle from "../ObjectHandle.js";
const d3 = global.d3;

import {simplify} from "svg-utils";

const CurvedLine = function(group, color) {
    this.data = {
        id: `local-${uuid()}`,
        segments_number: 0,
        segments: [[]],
        color: color,
        class: ["node", "line", "object", "movable", "removable"],
        storage: "object"
    };
    this.group = group;
    this.handle = null;
    this.node = null;
    this.line = null;
    this.position = {
        x: 0,
        y: 0
    };
};
CurvedLine.prototype.render_driver = d3.line().x((d) => d.x).y((d) => d.y).curve(d3.curveLinear);
CurvedLine.prototype.render = function() {
    const data = this.data.segments.reduce((s1, s2) => s1.concat(s2));
    return this.render_driver(simplify(data, 3 / global.scene.root_transform.k, true));
};
CurvedLine.prototype.draw = function(x, y) {
    this.group.select(`#${this.data.id}`).remove();
    this.handle = this.group.append("g").attr("class", "handle").attr("id", this.data.id);
    this.node = this.handle.append("g").attr("class", this.data.class.join(" "));
    this.node.attr("data-type", "graphics");
    this.node.attr("data-subtype", "line");
    this.data.segments[0].push({x, y});
    this.position.x = x;
    this.position.y = y;
    this.line = this.node.append("path")
        .attr("stroke", this.data.color).attr("stroke-width", 3).attr("stroke-opacity", 1)
        .attr("fill", "none")
        .attr("d", this.render());
};
CurvedLine.prototype.update = function(x, y) {
    let dx = x - this.position.x;
    let dy = y - this.position.y;
    // check size of segment
    if (Math.sqrt(Math.pow(dx, 2) + Math.pow(dy, 2)) < 5 / global.scene.root_transform.k) {
        return;
    }

    // add segment
    let N = this.data.segments_number;
    this.data.segments[N].push({x, y});
    this.line
        .attr("stroke", this.data.color)
        .attr("d", this.render());
    this.position.x = x;
    this.position.y = y;
};
CurvedLine.prototype.add_segment = function() {
    let N = this.data.segments_number;
    this.data.segments[N] = [this.data.segments[N].shift(), this.data.segments[N].pop()];
    this.data.segments.push([this.data.segments[N][1]]);
    this.data.segments_number = N + 1;
    this.line
        .attr("stroke", this.data.color)
        .attr("d", this.render());
};
CurvedLine.prototype.end = function() {
    let object_handle = ObjectHandle({
        x: this.position.x,
        y: this.position.y,
        color: this.data.color
    });
    this.node.append(() => object_handle.node());
    return Promise.resolve();
};
CurvedLine.prototype.points = function(interval) {
    var line_node = this.line.node();
    var line_length = line_node.getTotalLength();
    var points_number = line_length / interval;
    return d3.range(points_number).map((d) => line_node.getPointAtLength(d * interval));
};
CurvedLine.prototype.is_empty = function() {
    let N = this.data.segments_number;
    return (this.data.segments[N].length === 0);
};
CurvedLine.prototype.detach = function() {
    this.handle = null;
    this.node = null;
    this.line = null;
};
CurvedLine.prototype.export = function() {
    return this.handle;
};
export default CurvedLine;
